import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserDataService } from '../core/services/user-data.service';
import { API_URL } from '../shared/constants/apiurl-constants';
import { role } from '../shared/constants/role-enum';
import { EngagementListDto } from '../shared/models/engagement/engagement-list-dto';
import { Engagement } from '../shared/models/engagement/engagement.model';
import { GetAllUsersResponse } from '../shared/models/get-all-users-response.model';
import { GetClientsResponse } from '../shared/models/get-clients-response.model';
import { SessionService } from '../shared/session-service/session.service';
import { TaxPeriod } from 'src/app/shared/models/engagement/TaxPeriod';
import { TaxPeriodQre } from '../shared/tax-year-qre/models/tax-year-qre.model';

@Injectable({
  providedIn: 'root'
})
export class ManageStudyService {
  engagementName: string;
  engagementNumber: string;
  navigationScreen: string;
  engagementRefresh = new BehaviorSubject(<Engagement | EngagementListDto[]>{});
  homeTableRefresh = new BehaviorSubject({});
  private clientUsersDataSource = new BehaviorSubject<GetClientsResponse>({} as GetClientsResponse);
  clientUsersDataSource$ = this.clientUsersDataSource.asObservable();

  private kpmgUsersDataSource = new BehaviorSubject<GetAllUsersResponse>({} as GetAllUsersResponse);
  kpmgUsersDataSource$ = this.kpmgUsersDataSource.asObservable();
  userRole: number;


    constructor(private sessionService: SessionService, private _userDataService: UserDataService) {
      this._userDataService.userDetails$.subscribe(userData => {
          const isClientAdmin = userData.roleId === role.clientAdmin;
          this.userRole = userData.roleId;

          if (this.userRole !== role.clientManager && this.userRole !== role.respondent && !isClientAdmin) {
              this.getClientNames();
              // this.getKpmgUsers();
          }
      });
  }

  refreshHomeTable() {
    this.homeTableRefresh.next(true);
  }

  refreshEngagement(engagement: Engagement | EngagementListDto[]) {
    this.engagementRefresh.next(engagement);
  }

  GetKPMGUsers() {
    return this.sessionService.apiUrlGet(API_URL.CLIENT.GET_ALL_USER);
  }


  CheckEngagementNumber(engagementNumber: any) {
    return this.sessionService.apiUrlGet(
      API_URL.ENGAGEMENT.CHECKENGAGMENTNUMBER +
        '?engagementNumber=' +
        engagementNumber,
    );
  }

  CheckEngagementName(engagementName: any, clientIdSelected: number) {
    return this.sessionService.apiUrlGet(
      API_URL.ENGAGEMENT.CHECKENGAGEMENTNAME +
        '?engagementName=' +
        engagementName +
        '&clientId=' +
        clientIdSelected,
    );
  }

  UpdateEngagement(engagement: any) {
    return this.sessionService.apiUrlPost(
      API_URL.ENGAGEMENT.EDITENGAGEMENT,
      engagement,
    );
  }

  GetEngagementById(engagementId: number, updateRecentlyViewedEngagement: boolean = false) {
    return this.sessionService.apiUrlGet(
      API_URL.ENGAGEMENT.GETENGAGEMENTBYID + '?engagementId=' + engagementId +
      '&updateRecentlyViewedEngagement=' + updateRecentlyViewedEngagement,
    );
  }

  getKpmgUsers() {
      this.sessionService.apiUrlGet(API_URL.CLIENT.GET_ALL_USER).subscribe(serviceResponse => {
          if (serviceResponse) {
              let kpmgUserResponse = serviceResponse as GetAllUsersResponse;
              this.kpmgUsersDataSource.next(kpmgUserResponse);
          }
      });
  }

  getKpmgUsersForDGClient(clientId: number) {
      // Add isDGClient=true as a query param
      const url = `${API_URL.CLIENT.GET_ALL_USER}?clientId=${clientId}&isDGClient=true`;
      this.sessionService.apiUrlGet(url).subscribe(serviceResponse => {
          if (serviceResponse) {
              let kpmgUserResponse = serviceResponse as GetAllUsersResponse;
              this.kpmgUsersDataSource.next(kpmgUserResponse);
          }
      });
  }

  getEmailReminderFrequencyOptions(): any {
      let emailReminderFrequencyOptions: any = {
          floor: 0,
          ceil: 10,
          getPointerColor: (value: number): string => {
              if (value === 0) {
                  return 'red';
              } else {
                  return '#28a745';
              }
          },
      };
      return emailReminderFrequencyOptions;
  }

  getClientNames() {
      this.sessionService.apiUrlGet(API_URL.GETCLIENTNAMES).subscribe(serviceResponse => {
          if (serviceResponse) {
              let clientDataResponse = serviceResponse as GetClientsResponse;
              this.clientUsersDataSource.next(clientDataResponse);
          }
      }, error => {
          console.log('Unable to get clients users: ' + error);
      });
  }

  GetClientUsers(clientId: number) {
      return this.sessionService.apiUrlGet(
          API_URL.CLIENT.GET_ALL_USER + '?clientId=' + clientId,
      );
  }

  CreateEngagement(engagement: any) {
      return this.sessionService.apiUrlPost(
          API_URL.ENGAGEMENT.CREATENGAGEMENT,
          engagement,
      );
}

  deleteTaxPeriod(taxPeriod) {
    return this.sessionService.apiUrlPost(
      API_URL.ENGAGEMENT.DELETETAXPERIOD,
      taxPeriod,
    );
  }

  getTaxPeriods(engagementId: number, isSortedTaxPeriod = false): Observable<TaxPeriod[]> {
    return this.sessionService.apiUrlGet(API_URL.ENGAGEMENT.GETTAXPERIODS + '?engagementId=' + engagementId + '&isSortedTaxPeriod=' + isSortedTaxPeriod) as Observable<TaxPeriod[]>;
  }

  getTaxPeriodQres(engagementId: number, taxperiodId: number): Observable<TaxPeriodQre> {
    return this.sessionService.apiUrlGet(API_URL.ENGAGEMENT.GET_TAX_PERIOD_QRE + '?engagementId=' + engagementId + '&taxPeriodId=' + taxperiodId) as Observable<TaxPeriodQre>;
  }
}
